import React from "react";
import styled from "styled-components";

interface SubHeaderFormsProps {
  icon?: JSX.Element;
  label: string;
}

const SubHeader: React.FC<SubHeaderFormsProps> = ({ icon, label }) => {
  return (
    <StyledHeader>
      {icon}
      <h4 className="label">{label}</h4>
    </StyledHeader>
  );
};

const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .label {
    margin-left: 15px;
  }
  svg {
    font-size: 30px;
  }
`;
export default SubHeader;
